import { Routes, Route } from "react-router-dom";
import Console from "./pages/Console";
// verison 2
function App() {
  return (
    <div style={{ minHeight: "100vh" }}>
      <Routes>
        <Route path="/" element={<Console />} />
      </Routes>
    </div>
  );
}

export default App;
